// extracted by mini-css-extract-plugin
export default {"container":"container___d5c1114658366e08"};